import React, { useState, useEffect } from "react";
import { useTranslation } from "../contexts/TranslationContext";
import ContactLink from "../components/ContactLink";
import close from "../images/close.svg";
import flowIcon from "../images/flowIcon.svg";
import { useParams } from "react-router-dom";

const HeroSection = () => {
  const { t } = useTranslation();
  const { lang } = useParams();
  const [bannerVisible, setBannerVisible] = useState(true);

  useEffect(() => {
    if (bannerVisible) {
      window.scrollTo(0, 0);
    }
  }, [bannerVisible]);

  const renderBanner = () => {
    if (!bannerVisible) return null;

    return (
      <div className="bg-btn-purple text-white p-4 flex items-center justify-center py-3 mt-2 md:mt-6">
        <div className="max-w-screen-lg w-full flex items-center justify-center flex-wrap">
          <span className="flex-1 text-center text-sm md:text-base">
            {t("bannerMessage")}
            <br className="block md:hidden" />
            <a
              href="https://www.linkedin.com/company/sapioo/"
              target="_blank"
              rel="noreferrer"
              className="underline ml-2"
            >
              https://www.linkedin.com/company/sapioo/
            </a>
          </span>
          <button
            onClick={() => setBannerVisible(false)}
            className="ml-auto mt-2 lg:mt-0"
          >
            <img src={close} alt="Close Icon" />
          </button>
        </div>
      </div>
    );
  };

  return (
    <>
      {renderBanner()}
      <section className={"py-16"}>
        <div
          className={
            "container px-4 mx-auto flex flex-col lg:grid justify-between gap-5 lg:gap-12"
          }
          style={{ gridTemplateColumns: "1fr 1fr" }}
        >
          <div className={"flex gap-10 flex-col"}>
            <h1 className={"text-2xl lg:text-4xl text-black"}>
              {t("mainTitle")}{" "}
              <span className="text-btn-purple">{t("singlePlatform")}</span>
            </h1>
            <p className={"text-base lg:text-xl text-black"}>
              {t("mainMessage")}
            </p>
            <div
              className={
                "flex flex-wrap md:flex-nowrap items-center gap-1 md:gap-10 justify-center md:justify-start"
              }
            >
              <a
                href={`${process.env.REACT_APP_SAPIOO_PORTAL_HOST}/${lang}`}
                target={"_blank"}
                rel="noreferrer"
                className={
                  "bg-btn-orange p-4 rounded-xl text-white flex justify-center items-center"
                }
                style={{ width: "177px", height: "66px" }}
              >
                {t("signIn")}
              </a>
              <ContactLink
                styles={
                  "bg-btn-purple p-4 rounded-xl text-white flex justify-center items-center"
                }
                text={t("requestDemo")}
                style={{ width: "177px", height: "66px" }}
              />
            </div>
          </div>
          <div className={"flex flex-col items-end gap-8 relative"}>
            <img src={flowIcon} alt="Flow Icon" className="w-full h-auto" />
          </div>
        </div>
      </section>
    </>
  );
};

export default HeroSection;
